import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Grid, Typography, Box } from "@mui/material";
import { Button } from "abs-ui-components";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import RichTextEditor from "../../RichTextEditor/RichTextEditor";

const DataQuality = ({ seempIIDataquality, refetchMonitoringData, vesselMstId }) => {
	const [editorContent, setEditorContent] = useState("");
	const [lastSavedContent, setLastSavedContent] = useState(""); // Track saved state
	const [error, setError] = useState("");
	const editorRef = useRef(null);

	useEffect(() => {
		if (seempIIDataquality) {
			setEditorContent(seempIIDataquality);
			setLastSavedContent(seempIIDataquality); // reset saved content
		}
	}, [seempIIDataquality]);

	const handleSave = async () => {
		if (!editorRef.current) return;

		const editorHTML = editorRef.current.getHTML().trim();
		const cleaned = editorHTML
			.replace(/<p><br><\/p>/g, "")
			.replace(/&nbsp;/g, "")
			.trim();
		const hasContent = cleaned.length > 0 && cleaned !== "<p></p>" && cleaned !== "<br>" && cleaned !== "";
		if (!hasContent) {
			setError("Field is Required");
			return;
		}


		try {
			const res = await callApi({
				method: "POST",
				url: API_ROUTES.DataQuality(vesselMstId),
				data: JSON.stringify(editorHTML),
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (res?.isSuccess) {
				emitToasterMsg("success", "Data Quality", "Saved successfully");
				await refetchMonitoringData?.();
				setError("");
				setLastSavedContent(editorHTML); // update last saved state
			} else {
				emitToasterMsg("error", "Data Quality", res?.errorMessage);
			}
		} catch (err) {
			emitToasterMsg("error", "Data Quality", err.message);
		}
	};

	const isSaveDisabled = editorContent === lastSavedContent;

	return (
		<Box mt={3}>
			<Grid container spacing={2} alignItems="flex-start">
				<Grid item xs={12} md={2}>
					<Typography variant="body2" fontWeight={600} mb={1}>
						Description <span style={{ color: "red" }}>*</span>
					</Typography>
				</Grid>

				<Grid item xs={12} md={9}>
					<Box border="1px solid #ccc" borderRadius={1} p={1} sx={{ background: "#fff" }}>
						<RichTextEditor
							ref={editorRef}
							value={editorContent}
							onChange={setEditorContent} // make editor update state
							placeholder="Enter the description for the laden distance travelled..."
						/>
					</Box>

					{error && (
						<Typography variant="caption" color="error" mt={1}>
							{error}
						</Typography>
					)}

					<Box mt={2}>
						<Button onClick={handleSave} size="small" disabled={isSaveDisabled}>
							Save
						</Button>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default DataQuality;
